import { CRM_WEB_PAGES_URLS } from '../CRM_WEB_PAGES_URLS';
import { ADMIN_WEB_PAGES_URLS } from '../EMR_WEB_PAGES_URLS';
import { PATIENT_WEB_PAGES_URLS } from '../PATIENT_WEB_PAGES_URLS';
import { usStates } from '../data';
import { OrganizationSettings } from '@care-portals/api-interfaces';

export const fifty410: OrganizationSettings = {
  name: 'Fifty410',
  replyToEmail: 'no-reply@fifty410.com',
  ecommerceEnabled: true,
  stripeEnabled: true,
  patientPortalDomain: 'fifty410.portals.care',
  // pharmacyEmail: 'pharmacy@fifty410.com',
  // customerServiceEmail: 'help@fifty410.com',
  noMarketingListId: '',
  bigcommerceCustomerGroupId: 0,
  conversationServiceId: 'IS9d8b15500b914f3a98bff0a083e18592',
  // adminCustomDomain: 'emr.portals.care',
  currency: 'usd',
  appointmentconsentSection: `
    <p style="text-align: center;color: #536476;">
    By clicking on {{cta_label}} you agree to our:<br />
    <a
      href="javascript:window.open('https://fifty410.com/privacy-policy', 'popup', 'width=600,height=600');"
    >
        Privacy Policies
    </a>
    <br>
    <a
      href="javascript:window.open('https://fifty410.com/terms-conditions', 'popup', 'width=600,height=600');"
    >
    Terms & Conditions
    </a>
      </p>
    `,

  // navigation
  crmWebAppLayout: {
    title: 'fifty410',
    icon: '',
    locations: [...usStates.map(s => ({ label: s.province, value: s.code }))],
    mainMenu: [
      {
        title: 'Leads',
        link: CRM_WEB_PAGES_URLS.leads.list,
        icon: 'fa-regular fa-address-book',
        roles: ['*']
      },
      {
        title: 'Appointments',
        link: CRM_WEB_PAGES_URLS.appointments.calendar,
        icon: 'fa-regular fa-calendar-check',
        roles: ['*']
      },
      {
        title: 'Tasks',
        link: CRM_WEB_PAGES_URLS.tasks.list,
        icon: 'fa-solid fa-list-check',
        roles: ['*']
      },
      {
        title: 'Segments',
        link: CRM_WEB_PAGES_URLS.segment.list,
        icon: 'fa-solid fa-table-columns',
        roles: ['*']
      },
      {
        title: 'Store Manager',
        link: '',
        icon: 'fas fa-shop',
        roles: ['admin', 'developer', 'owner'],
        items: [
          {
            title: 'Products',
            link: CRM_WEB_PAGES_URLS.products.list,
            icon: 'fas fa-product'
          },
          {
            title: 'Coupons',
            link: CRM_WEB_PAGES_URLS.coupons.list,
            icon: 'fas fa-gift'
          },
          {
            title: 'Promotions',
            link: CRM_WEB_PAGES_URLS.promotions.list,
            icon: 'fas fa-gift'
          }
        ]
      },
      {
        title: 'Admin',
        link: '',
        icon: 'fas fa-user-cog',
        roles: ['admin', 'developer', 'owner'],
        items: [
          {
            title: 'Services',
            link: CRM_WEB_PAGES_URLS.services.list,
            icon: 'fas fa-medkit'
          },
          {
            title: 'Schedules',
            link: CRM_WEB_PAGES_URLS.schedules.list,
            icon: 'fas fa-calendar'
          },
          {
            title: 'Users',
            link: CRM_WEB_PAGES_URLS.users.list,
            icon: 'fas fa-lock'
          },
          {
            title: 'Layouts',
            link: CRM_WEB_PAGES_URLS.layouts.list,
            icon: 'fas fa-columns'
          },
          {
            title: 'Schemas',
            link: CRM_WEB_PAGES_URLS.crmSchemas.list,
            icon: 'fas fa-receipt'
          },
          {
            title: 'Forms',
            link: CRM_WEB_PAGES_URLS.forms.list,
            icon: 'fas fa-table'
          },
          {
            title: 'Workflows',
            link: CRM_WEB_PAGES_URLS.workflows.list,
            icon: 'fas fa-code-branch'
          },
          {
            title: 'Templates',
            link: CRM_WEB_PAGES_URLS.emailTemplates.list,
            icon: 'fas fa-palette'
          },
          {
            title: 'Settings',
            link: CRM_WEB_PAGES_URLS.settings.base,
            icon: 'fa-solid fa-sliders'
          }
        ]
      }
    ]
  },
  emrWebAppLayout: {
    title: 'FIFTY 410',
    defaultPingMsg:
      '🛎️ Ping! FIFTY 410 team is waiting for your response. To respond, please go to https://fifty410.portals.care/messages',
    questionnaires: [
      'facesheet',
      'facesheet_ext',
      'selfie',
      'govId',
      'bodySelfie',
      'wlus',
      'wlusmonthly'
    ],
    mainMenu: [
      {
        title: 'Patients',
        name: 'patients',
        link: ADMIN_WEB_PAGES_URLS.customers.allList,
        icon: 'fas fa-user-injured',
        roles: ['*']
      },
      {
        title: 'Consultations',
        name: 'consultations',
        link: ADMIN_WEB_PAGES_URLS.consultations.onlineList,
        icon: 'fas fa-user-md',
        roles: ['*']
      },
      {
        title: 'Orders',
        name: 'orders',
        link: ADMIN_WEB_PAGES_URLS.orders.allList,
        icon: 'fas fa-shopping-cart',
        roles: ['*']
      },
      {
        title: 'Subscriptions',
        name: 'subscriptions',
        link: ADMIN_WEB_PAGES_URLS.subscriptions.allList,
        icon: 'fas fa-bars',
        roles: ['*']
      },
      {
        title: 'Drugs',
        link: ADMIN_WEB_PAGES_URLS.drugs.allList,
        icon: 'fas fa-pills',
        roles: ['*']
      },
      {
        title: 'RXs',
        name: 'rxs',
        link: ADMIN_WEB_PAGES_URLS.prescriptions.allList,
        icon: 'fas fa-prescription',
        roles: ['pharmacy', 'admin', 'owner']
      }
    ]
  },
  patientWebAppLayout: {
    title: 'FIFTY 410',
    brand: 'fifty410',
    colors: {
      primaryColor: '#6D4C4C'
    },
    shopUrl: 'https://fifty410.com',
    // gtm: {
    // id: 'GTM-NN3FR4GP',
    //   url: 'https://gtm.fifty410.com/gtm.js'
    // },
    topAction: {
      title: 'Shop',
      link: 'https://fifty410.com'
    },
    logo: {
      img: 'https://cdn-ilbbeah.nitrocdn.com/FsOsYYaHtuzeZOsNpJckePOsOgXuOneJ/assets/images/optimized/rev-f06c925/fifty410.com/wp-content/uploads/2024/06/cropped-FIFTY410-icon-v1.png',
      link: '/home'
    },
    referrals: {
      enabled: false,
      referrerAmount: 50,
      refereeAmount: 30,
      referralURI: 'https://fifty410.com/auth/signup',
      referralFAQ: 'https://fifty410.com/referral-rewards/'
    },
    privacyPolicyUrl: 'https://fifty410.com/privacy-policy',
    termsOfUseUrl: 'https://fifty410.com/terms-of-use',
    stripePublicKey:
      'pk_live_51POIkSB8X6dBXXp8gisBtkqUXP4zTiX0Xq6O2GNC50r7fkYBxML8LP7rQj8lIEwSIDlE63qvW0jsQWqcSiShxPgP00ZJWK4gwW',
    availableStates: {
      us: [
        ...usStates
        // .filter(
        // s => !['AR', 'CA', 'LA', 'AL', 'MS'].includes(s.code)
        // )
      ]
    },
    mainMenu: [
      {
        title: 'Profile',
        link: PATIENT_WEB_PAGES_URLS.account.profile,
        svg: 'assets/icons/profile.svg',
        roles: ['*']
      },
      {
        title: 'Orders',
        link: PATIENT_WEB_PAGES_URLS.account.orders,
        svg: 'assets/icons/orders.svg',
        roles: ['*']
      },
      {
        title: 'Consultations',
        link: PATIENT_WEB_PAGES_URLS.account.consultations,
        svg: 'assets/icons/consultations.svg',
        roles: ['*']
      },
      {
        title: 'Prescriptions',
        link: PATIENT_WEB_PAGES_URLS.account.prescriptions,
        svg: 'assets/icons/rxs.svg',
        roles: ['*']
      },
      {
        title: 'Medical Inbox',
        link: PATIENT_WEB_PAGES_URLS.messages.inbox,
        svg: 'assets/icons/medical-chat.svg',
        roles: ['*']
      },
      {
        title: 'Billing',
        link: 'billing',
        svg: 'assets/icons/billing.svg',
        type: 'external',
        roles: ['*']
      },
      {
        title: 'Shop',
        link: 'shop',
        svg: 'assets/icons/shop.svg',
        type: 'external',
        roles: ['*']
      }
    ]
  },
  pharmacies: {
    // Curexa: {
    //   _id: '65e1ed1d8cd6e41498619bc4',
    //   belugaId: '29992',
    //   states: [
    //     'CA',
    //     'GA',
    //     'ID',
    //     'IL',
    //     'IA',
    //     'MA',
    //     'NE',
    //     'NH',
    //     'NM',
    //     'ND',
    //     'OH',
    //     'WA',
    //     'MD',
    //     'NV',
    //     'NJ',
    //     'NC',
    //     'WI',
    //     'AZ',
    //     'CO',
    //     'CT',
    //     'DE',
    //     'DC',
    //     'FL',
    //     'KS',
    //     'LA',
    //     'ME',
    //     'MN',
    //     'MS',
    //     'MO',
    //     'MT',
    //     'NY',
    //     'OK',
    //     'OR',
    //     'PA',
    //     'RI',
    //     'SD',
    //     'TN',
    //     'TX',
    //     'UT',
    //     'WV',
    //     'WY',
    //     'AL',
    //     'AK',
    //     'AR',
    //     'IN',
    //     'KY',
    //     'MI',
    //     'SC',
    //     'VT',
    //     'VA'
    //   ]
    // }
  }
};
